export enum SlotType {
    sdcard = 'sdcard',
    memorystick = 'memorystick',
    none = 'none',
}
